import React, {useState, useEffect, useContext} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import SubMenuView from '../../views/subMenuView';
import {useMenu} from '../../../hooks/useMenu';
import ChannelConfig from './channel-config';
import FCFTN from './fcfTN';
import ConfigurationSummary from './config-summary';
import CommandsContext from '../../../context/commandsContext';
import {useTranslation, withTranslation, Trans} from 'react-i18next';

function SensorParameters() {
  const yesNoItem = [
    {id: 1, name: 'Yes', component: <FCFTN />},
    {id: 2, name: 'No', component: <ConfigurationSummary />},
  ];
  const leftPress = useKeyPress('ArrowLeft');
  const {onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands}));
  }, []);

  const {t, i18n} = useTranslation();
    const changeLanguage = lng => {
      i18n.changeLanguage(lng);
    };

  // useEffect(() => {
  //   if (!leftPress || isKeypressDisabled) return;

  //   onComponent(<ChannelConfig />);
  // }, [leftPress]);

  return (
    <SubMenuView
      title={t('sensorParam.title')}
      menuItems={yesNoItem}
      content={t('sensorParam.a1')}
      isMenuDisabled
      onLeftCallback={() => onComponent(<ChannelConfig />)}
    />
  );
}
export default SensorParameters;
